
const SET_DOCUMENTS = (state, payload) => {
  state.documents = payload
}

const PUSH_FILE = (state, payload) => {
  state.documents.push(payload)
}

const REMOVE_FILE = (state, id) => {
  state.documents = state.documents.filter(x => x.id !== id)
}

const REPLACE_FILE = (state, payload) => {
  // console.log('replace file')
  // console.log(payload)
  let indexOf = state.documents.map(function (e) { return e.id }).indexOf(payload.id)
  //   x => x.id === payload.id)
  console.log(indexOf)
  state.documents[indexOf] = payload
}

const SET_CURRENTDIR = (state, payload) => {
  state.folderPickerCurrentDir = payload
}

const SET_CURRENTITEM = (state, payload) => {
  state.selectedItemId = payload.itemId
  state.selectedItemName = payload.name
}

const SET_NEXTLINK = (state, payload) => {
  state.nextLink = payload
}

const SET_FOLDEDRNEXTLINK = (state, payload) => {
  state.foldersNextLink = payload
}

const APPEND_DOCUMENTS = (state, payload) => {
  state.documents = state.documents.concat(payload)
}

const APPEND_FOLDERS = (state, payload) => {
  state.folderPickerCurrentDir = state.documents.concat(payload)
}
export default {
  SET_DOCUMENTS,
  PUSH_FILE,
  REMOVE_FILE,
  REPLACE_FILE,
  SET_CURRENTDIR,
  SET_CURRENTITEM,
  SET_NEXTLINK,
  APPEND_DOCUMENTS,
  SET_FOLDEDRNEXTLINK,
  APPEND_FOLDERS
}
